// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"414901f3","977":"e3bbec5b"}[chunkId] + ".chunk.js";
};